declare global {
  interface Window {
    WPGlobusWidgetsBlockEditor: any;
    React: any;
  }
}

export default function AppConfig() {
  if (
    process.env.NODE_ENV === "development" ||
    process.env.NODE_ENV === "test"
  ) {
    // values are: 'development', 'test', 'production'.
    return {
      wpVersion: "6.0.1",
      version: "2.10.4",
      switcherVersion: "2.0.0",
      NODE_ENV: process.env.NODE_ENV,
      homeUrl: "http://localhost:3000/",
      currentUrl: "http://localhost:3000/",
      href: "http://localhost:3000/",
      pagenow: "widgets.php",
      flag: {
        en: "us.png",
        ru: "ru.png",
        es: "es.png",
        de: "de.png",
        fr: "fr.png",
      },
      flagUrls: {
        small: "http://www.dev-wpg.com/wp-content/plugins/wpglobus/flags/",
        big: "http://www.dev-wpg.com/wp-content/plugins/wpglobus/flags/big/",
      },
      imageUrl: "http://www.dev-wpg.com/",
      defaultLanguage: "en",
      enabledLanguages: ["en", "ru", "es", "de", "fr"],
      enLanguageName: {
        en: "English",
        ru: "Russian",
        es: "Spanish",
        de: "German",
        fr: "French",
      },
      extraLanguages: ["en", "es", "de", "fr"],
      currentLanguage: ["ru"],
      languageFlagUrl: {
        en: "http://www.dev-wpg.com/wp-content/plugins/wpglobus/flags/big/us.png",
        ru: "http://www.dev-wpg.com/wp-content/plugins/wpglobus/flags/big/ru.png",
        es: "http://www.dev-wpg.com/wp-content/plugins/wpglobus/flags/big/es.png",
        de: "http://www.dev-wpg.com/wp-content/plugins/wpglobus/flags/big/de.png",
        fr: "http://www.dev-wpg.com/wp-content/plugins/wpglobus/flags/fr.png",
      },
      wpgPremiumURL: "https://wpglobus.com/shop/",
      wpgOptionsURL:
        "http://www.dev-wpg.com/wp-admin/admin.php?page=wpglobus_options&tab=block-editor",
      optionIcon: {
        en: "http://www.dev-wpg.com/wp-content/plugins/wpglobus/includes/widgets/assets/css/images/icon-ok.png",
        ru: "http://www.dev-wpg.com/wp-content/plugins/wpglobus/includes/widgets/assets/css/images/icon-ok.png",
        es: "",
        de: "http://www.dev-wpg.com/wp-content/plugins/wpglobus/includes/widgets/assets/css/images/icon-ok.png",
        fr: "",
      },
      wpDebug: true,
      reactVersion: "18.2.0",
      buildStat: "// see in production",
    };
  } else {
    /**
     * production
     */
    window.WPGlobusWidgetsBlockEditor.reactVersion = window.React.version;
    return window.WPGlobusWidgetsBlockEditor;
  }
}
